import { RootState } from "app/store";
import LiveCarStaffCard from "components/card/LiveCarStaffCard";
import Menu from "components/common/Menu";
import LiveCarStaffHeader from "components/header/LiveCarStaffHeader";
import { SideBarTabs } from "constants/tabs";
import AppCopy from "copy/AppCopy";
import { useTabActive } from "hook/useTabActive";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CommonStyles } from "styles/CommonStyles";
import useAdminOnly from "hook/useAdminOnly";
import useUser from "hook/useUser";
import { useParams } from "react-router-dom";
import { CarType } from "types/loadedData";
import useCars from "hook/useCars";
import PageHeader from "components/common/PageHeader";
import EmptyState from "components/common/EmptyState";
import LoadMoreButton from "components/common/LoadMoreButton";

function OneStaffPage() {
  const params = useParams();
  const { getOneStaff, staffSuspension } = useUser();
  const { getLiveCars } = useCars();
  // const { liveCars } = useSelector((state: RootState) => state.car);
  const { staff } = useSelector((state: RootState) => state.user);
  const [activities, setActivities] = useState<CarType[]>([]);
  const [loadingMore, setLoadingMore] = useState<boolean>(false);
  const [suspensionLoading, setSuspensionLoading] = useState<boolean>(false);

  const loadData = async () => {
    if (!params?.id) return;
    if (!staff) {
      await getOneStaff({ id: params.id });
    }
    const response = await getLiveCars(
      { statusChangedBy: params.id },
      { local: true }
    );
    if (response) setActivities(response);
  };

  useAdminOnly();

  useTabActive(SideBarTabs.Staff.name);

  useEffect(() => {
    loadData();
  }, []);

  const handleSuspend = async () => {
    if (suspensionLoading) return;
    if (!params.id) return;
    await staffSuspension({
      setLoading: setSuspensionLoading,
      isActive: !staff?.isActive,
      id: params.id,
    });
  };

  const handleLoadMore = async () => {
    const response = await getLiveCars(
      {
        statusChangedBy: params.id,
        offset: activities.length,
        setLoading: setLoadingMore,
      },
      { local: true }
    );
    if (response) setActivities([...activities, ...response]);
  };

  const { suspendButtonText, titleText, unSuspendButtonText } =
    AppCopy.oneStaffPage;

  return (
    <div className={CommonStyles.pageWrapper}>
      <Menu />
      <PageHeader
        title={staff?.name || titleText}
        description="Review staff details and listing activity."
        actions={
          staff ? (
            <button className={ClassName.suspendButton} onClick={handleSuspend}>
              {staff.isActive ? suspendButtonText : unSuspendButtonText}
            </button>
          ) : null
        }
      />
      <div className={ClassName.container}>
        <div className={ClassName.profileCard}>
          <span className={ClassName.name}>{staff?.name || "Loading..."}</span>
          <span className={ClassName.phone}>{staff?.phoneNumber || "No phone"}</span>
          <span className={ClassName.email}>{staff?.email || "No email"}</span>
        </div>
        {/* <span className={ClassName.listTitle}>{listTitle}</span> */}
        <LiveCarStaffHeader />
        {activities.map((car) => (
          <LiveCarStaffCard key={String(car._id)} car={car} />
        ))}
        {!activities.length ? (
          <EmptyState title="No staff activity" description="Listing updates by this staff member will appear here." />
        ) : null}
        {activities.length > 19 && (
          <LoadMoreButton onClick={handleLoadMore} loading={loadingMore} />
        )}
      </div>
    </div>
  );
}

export default OneStaffPage;

const ClassName = {
  container:
    "flex min-h-56 flex-col rounded-2xl border border-slate-200 bg-white p-4",
  profileCard: "mb-5 flex flex-col rounded-xl bg-slate-50 p-4",
  suspendButton:
    "flex h-10 cursor-pointer items-center justify-center rounded-lg bg-primary px-4 text-sm font-semibold text-white",
  name: "text-primaryText font-semibold text-base mt-2",
  phone: "text-sm text-secondaryText",
  email: "text-sm text-secondaryText mb-4",
  listTitle: "text-primaryText font-semibold text-base",
};
